import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import usePermissions from "hooks/usePermissions";
import { useGetShipmentBasic } from "api/queries/shipments/useGetShipmentBasic";

function useCustomBrokerPermission(isQuickRequest: boolean = false) {
  const [isCustomBroker, setIsCustomBroker] = useState(false);

  const { permissions } = usePermissions();
  const id = useParams().id?.toUpperCase();
  const { data: shipmentData } = useGetShipmentBasic(id!, {
    enabled: !isQuickRequest && !!id,
    refetchOnMount: false,
  });

  const { customs_broker_ref, provider_team_ref } = shipmentData?.shipment ?? {};

  // Extract the provider and custom broker teams from the permissions object
  const providerTeamValues = JSON.parse(permissions ?? "{}")?.provider_teams?.teams.map(
    (team: { value: string }) => team.value,
  );
  const customBrokerValues = JSON.parse(permissions ?? "{}")?.custom_broker_teams?.teams.map(
    (team: { value: string }) => team.value,
  );

  const checkIfIsCustomBroker = () => {
    if (!customs_broker_ref) setIsCustomBroker(false);
    else if (
      customs_broker_ref !== provider_team_ref &&
      !providerTeamValues?.includes(provider_team_ref) &&
      customBrokerValues?.includes(customs_broker_ref)
    )
      setIsCustomBroker(true);
  };

  useEffect(() => {
    checkIfIsCustomBroker();
  }, [customs_broker_ref, provider_team_ref, permissions]);

  return [isCustomBroker];
}

export default useCustomBrokerPermission;
